"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constant = void 0;
var tslib_1 = require("tslib");
/**
 * Created by wangtong on 2021/1/4
 */
var Constant;
(function (Constant) {
    function toOptions(config) {
        if (Array.isArray(config)) {
            return config;
        }
        else {
            var options = [];
            for (var key in config) {
                if (config.hasOwnProperty(key)) {
                    options.push(tslib_1.__assign({ key: key }, config[key]));
                }
            }
            return options;
        }
    }
    Constant.toOptions = toOptions;
    function getOptionByValue(config, value, matcher) {
        if (Array.isArray(config)) {
            for (var _i = 0, config_1 = config; _i < config_1.length; _i++) {
                var option = config_1[_i];
                if (typeof matcher === "function") {
                    if (matcher(value, option)) {
                        return option;
                    }
                }
                else if (value == option.value) {
                    return option;
                }
            }
        }
        else {
            for (var key in config) {
                if (config.hasOwnProperty(key)) {
                    // 弱匹配，这样不需要针对字符串和数值进行区别处理了
                    var option = config[key];
                    option.key = key;
                    if (typeof matcher === "function") {
                        if (matcher(value, option)) {
                            return option;
                        }
                    }
                    else if (value == option.value) {
                        return option;
                    }
                }
            }
        }
    }
    Constant.getOptionByValue = getOptionByValue;
    function getOptionByLabel(config, label, matcher) {
        if (Array.isArray(config)) {
            for (var _i = 0, config_2 = config; _i < config_2.length; _i++) {
                var option = config_2[_i];
                // 弱匹配，这样不需要针对字符串和数值进行区别处理了
                if (typeof matcher === "function") {
                    if (matcher(label, option)) {
                        return option;
                    }
                }
                else if (label === option.label) {
                    return option;
                }
            }
        }
        else {
            for (var key in config) {
                if (config.hasOwnProperty(key)) {
                    // 弱匹配，这样不需要针对字符串和数值进行区别处理了
                    var option = config[key];
                    option.key = key;
                    if (typeof matcher === "function") {
                        if (matcher(label, option)) {
                            return option;
                        }
                    }
                    else if (label === option.label) {
                        return option;
                    }
                }
            }
        }
    }
    Constant.getOptionByLabel = getOptionByLabel;
    function getKey(config, value, matcher) {
        var _a;
        return (_a = getOptionByValue(config, value, matcher)) === null || _a === void 0 ? void 0 : _a.key;
    }
    Constant.getKey = getKey;
    function getKeyByLabel(config, label, matcher) {
        var _a;
        return (_a = getOptionByLabel(config, label, matcher)) === null || _a === void 0 ? void 0 : _a.key;
    }
    Constant.getKeyByLabel = getKeyByLabel;
    function getLabel(config, value, matcher) {
        var _a;
        return (_a = getOptionByValue(config, value, matcher)) === null || _a === void 0 ? void 0 : _a.label;
    }
    Constant.getLabel = getLabel;
    function getHint(config, value, matcher) {
        var _a;
        return (_a = getOptionByValue(config, value, matcher)) === null || _a === void 0 ? void 0 : _a.hint;
    }
    Constant.getHint = getHint;
    function getValue(config, label, matcher) {
        var _a;
        return (_a = getOptionByLabel(config, label, matcher)) === null || _a === void 0 ? void 0 : _a.value;
    }
    Constant.getValue = getValue;
    function getColor(config, value, matcher) {
        var _a;
        return (_a = getOptionByValue(config, value, matcher)) === null || _a === void 0 ? void 0 : _a.color;
    }
    Constant.getColor = getColor;
    function getMeta(config, value, matcher) {
        var _a;
        return (_a = getOptionByValue(config, value, matcher)) === null || _a === void 0 ? void 0 : _a.meta;
    }
    Constant.getMeta = getMeta;
    function extractValue() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 1) {
            return args[0];
        }
        else if (args.length === 4) {
            return args[2];
        }
        else {
            return undefined;
        }
    }
    Constant.extractValue = extractValue;
    function format() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var config = args[0];
        if (args.length === 1) {
            return function () {
                var args1 = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args1[_i] = arguments[_i];
                }
                var value = extractValue.apply(null, args1);
                return getLabel(config, value);
            };
        }
        else {
            var value = extractValue.apply(null, args.slice(1));
            return getLabel(config, value);
        }
    }
    Constant.format = format;
})(Constant || (Constant = {}));
exports.Constant = Constant;
//# sourceMappingURL=constant.js.map